(function () {
  $(document).ready(function () {
    var $createSetSection = $(".ga-create-set-section");

    if (!$createSetSection.length || typeof $.fn.slick !== "function") {
      return;
    }

    if (window.innerWidth < 800) {
      if ($("#mobile-create-set").length) {
        $createSetSection.appendTo("#mobile-create-set");
      }

      if ($("#shopify-section-footer").length && $("#m-footer").length) {
        $("#shopify-section-footer").appendTo("#m-footer");
      }
    }

    var handleClicks = function () {
      var $addToCart = $("#ga-set-atc");
      var v1 = false;
      var v2 = false;

      if (!$addToCart.length) {
        return;
      }

      $addToCart.attr("disabled", true);

      $(".ga-set-slider-section .product-option-size.op-product-option")
        .off("click.beyondCreateSet")
        .on("click.beyondCreateSet", function () {
          var $option = $(this);
          var i = $option.attr("data-i");

          if (i === "0") {
            v1 = $option.attr("data-vid");
          }

          $(".ga-set-slider-section.set-" + i + " .product-option-size.op-product-option").removeClass(
            "ga-active"
          );
          $option.addClass("ga-active");

          if (i === "1") {
            v2 = $option.attr("data-vid");
          }

          if (v1 !== false && v2 !== false) {
            $addToCart.attr("disabled", false);
            $addToCart.attr("v1", v1);
            $addToCart.attr("v2", v2);
          } else {
            $addToCart.attr("disabled", true);
          }

          $addToCart.off("click.beyondCreateSet").on("click.beyondCreateSet", function () {
            CartJS.addItem(parseInt($(this).attr("v1"), 10));
            CartJS.addItem(parseInt($(this).attr("v2"), 10));
          });
        });
    };

    var renderData = function (ind, pos) {
      var $activeMeta = $(
        ".ga-set-slider-section.set-" + pos + " .ga-set-slide.slick-active.slick-center .ga-set-meta"
      ).first();

      if (!$activeMeta.length) {
        $activeMeta = $(
          ".ga-set-slider-section.set-" + pos + " .ga-set-slide.slick-current .ga-set-meta"
        ).first();
      }

      $(".ga-set-slider-section.set-" + pos + " .ga-set-right .ga-set-desc").html(
        $activeMeta.html() || ""
      );
      handleClicks(ind);
    };

    $(".ga-set-slider").each(function (index) {
      var $el = $(this);

      if ($el.hasClass("slick-initialized")) {
        return;
      }

      if ($el.children().length <= 3) {
        $el.children().clone().appendTo($el);
      }

      $el.on("init", function () {
        renderData(0, index);
      });

      $el.slick({
        slidesToShow: 3,
        centerMode: true,
        loop: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
        ],
      });

      $el.on("afterChange", function (slick) {
        renderData(slick.currentTarget.slick.currentSlide, index);
      });
    });
  });
})();

(function () {
  function getSelectedProductVaiants(wr, variants, isBundledProduct) {
    var container = wr || document;
    var allVariants = variants || (window._opPdt && window._opPdt.variants) || [];
    var bundled = Boolean(isBundledProduct);

    window.ga_showMsg(".hdl-pdp-atc-msg", "");

    if (!allVariants.length || !allVariants[0] || !allVariants[0].options) {
      return false;
    }

    var formWrSelector = bundled ? ".bundled-product-options" : ":not(.bundled-product-options)";
    var optElems = container.querySelectorAll(".product-options" + formWrSelector + " .option-selected");
    var options = [];

    if (optElems.length === allVariants[0].options.length) {
      optElems.forEach(function (e) {
        options.push(e.dataset.value);
      });
      var fVar = allVariants.filter(function (v) {
        return _.isEqual(v.options, options);
      });
      if (fVar.length === 1) {
        return fVar[0];
      }
    }

    return false;
  }

  function submitCustomLengthForm(e, submitBtn) {
    if (e.__customLengthHandled) {
      return;
    }
    e.__customLengthHandled = true;

    try {
      e.preventDefault();
      if (submitBtn) {
        submitBtn.classList.add("loading-inline");
      }

      var formDataObject = new FormData(e.target);
      var formValues = Object.fromEntries(formDataObject.entries());
      var height = formValues.height;
      var heightUnit = formValues.heightUnit;
      var dressLength = formValues.dressLength;
      var dressLengthUnit = formValues.dressLengthUnit;

      if (!height || Number(height) <= 0 || !dressLength || Number(dressLength) <= 0) {
        throw new Error("Please enter a valid height and dress length");
      }

      var selectedVariant = getSelectedProductVaiants();
      if (!selectedVariant) {
        throw new Error("Please select the product options");
      }

      var qtyInput = document.querySelector('.atc-wrapper input[name="quantity"]');
      var qty = Number((qtyInput && qtyInput.value) || 1);

      CartJS.addItem(
        selectedVariant.id,
        qty,
        {
          Height: "" + height + heightUnit,
          "Dress Length": "" + dressLength + dressLengthUnit,
        },
        {
          success: function () {
            var sideDrawerEl = document.querySelector("side-drawer");
            sideDrawerEl && sideDrawerEl.closeDrawer();
            closeCustomLengthDrawer();
            $(".cartleft .drawer__body1").slideToggle("slow", function () {
              window.setTimeout(function () {
                $(".cartleft .drawer__body1").slideToggle("slow");
              }, 5000);
            });
            e.target && e.target.reset();
            if (submitBtn) {
              submitBtn.classList.remove("loading-inline");
            }
          },
          error: function (jqXHR) {
            window.ga_showMsg(
              ".hdl-pdp-atc-msg",
              "<span class='txt-red'>" + jqXHR.responseJSON.description + "</span>"
            );
            if (submitBtn) {
              submitBtn.classList.remove("loading-inline");
            }
          },
        }
      );
    } catch (error) {
      Snackbar.show({
        pos: "top-right",
        text: (error && error.message) || "Something went wrong!",
        textColor: "#ff0000d4",
        actionTextColor: "#fff",
      });
      if (submitBtn) {
        submitBtn.classList.remove("loading-inline");
      }
    }
  }

  if (!customElements.get("custom-length-drawer")) {
    customElements.define(
      "custom-length-drawer",
      class CustomLengthDrawer extends HTMLElement {
        constructor() {
          super();
          this.customLengthForm = this.querySelector("#js-custom-length-form");
          this.customLengthFormSubmitBtnEl = this.querySelector("#js-custom-length-form-submit-btn");
          if (this.customLengthForm) {
            this.customLengthForm.addEventListener("submit", this.handleFormSubmit.bind(this));
          }
        }

        handleFormSubmit(e) {
          submitCustomLengthForm(e, this.customLengthFormSubmitBtnEl);
        }
      }
    );
  }

  if (!customElements.get("side-drawer")) {
    customElements.define(
      "side-drawer",
      class SideDrawer extends HTMLElement {
        constructor() {
          super();
          this.overlay = document.querySelector(".js-side-drawer-overlay");
          this.drawer = document.querySelector(".js-side-drawer");
          this.drawerContent = document.querySelector(".js-drawer-content");
          this.closeButtons = document.querySelectorAll(".js-drawer-close");
          this.isDrawerOpen = false;
          this.handleEscapeKeyBound = this.handleEscapeKey.bind(this);
          this.closeButtons.forEach(
            function (button) {
              button.addEventListener("click", this.closeDrawer.bind(this));
            }.bind(this)
          );
        }

        openDrawer(templateId) {
          if (this.isDrawerOpen) {
            this.closeDrawer();
            return;
          }

          var templateEl = document.getElementById(templateId);
          if (!templateEl) {
            return;
          }

          this.drawerContent.innerHTML = "";
          this.drawerContent.append(templateEl.content.cloneNode(true));
          this.isDrawerOpen = true;
          this.overlay.classList.add("active");
          this.drawer.classList.add("active");
          document.documentElement.style.overflow = "hidden";
          document.addEventListener("keydown", this.handleEscapeKeyBound);
        }

        closeDrawer() {
          if (!this.isDrawerOpen) {
            return;
          }
          this.isDrawerOpen = false;
          this.overlay.classList.remove("active");
          this.drawer.classList.remove("active");
          document.documentElement.style.overflow = "";
          document.removeEventListener("keydown", this.handleEscapeKeyBound);
        }

        handleEscapeKey(event) {
          if (event.key === "Escape") {
            this.closeDrawer();
          }
        }
      }
    );
  }

  if (!customElements.get("side-drawer-opener")) {
    customElements.define(
      "side-drawer-opener",
      class SideDrawerOpener extends HTMLElement {
        constructor() {
          super();
          this.addEventListener("click", function () {
            var sideDrawerEl = document.querySelector("side-drawer");
            if (!sideDrawerEl) {
              return;
            }
            sideDrawerEl.openDrawer(this.dataset.templateId);
          });
        }
      }
    );
  }

  document.addEventListener("click", function (event) {
    var opener = event.target && event.target.closest ? event.target.closest("side-drawer-opener") : null;
    if (!opener) {
      return;
    }
    var sideDrawerEl = document.querySelector("side-drawer");
    if (!sideDrawerEl || typeof sideDrawerEl.openDrawer !== "function") {
      return;
    }
    sideDrawerEl.openDrawer(opener.dataset.templateId);
  });

  // Fallback path: open/close drawer without relying on custom elements lifecycle.
  function openCustomLengthDrawer(templateId) {
    var overlay = document.querySelector(".js-side-drawer-overlay");
    var drawer = document.querySelector(".js-side-drawer");
    var drawerContent = document.querySelector(".js-drawer-content");
    var templateEl = document.getElementById(templateId);

    if (!overlay || !drawer || !drawerContent || !templateEl) {
      return;
    }

    drawerContent.innerHTML = "";
    drawerContent.append(templateEl.content.cloneNode(true));
    overlay.classList.add("active");
    drawer.classList.add("active");
    document.documentElement.style.overflow = "hidden";
  }

  function closeCustomLengthDrawer() {
    var overlay = document.querySelector(".js-side-drawer-overlay");
    var drawer = document.querySelector(".js-side-drawer");
    if (!overlay || !drawer) {
      return;
    }
    overlay.classList.remove("active");
    drawer.classList.remove("active");
    document.documentElement.style.overflow = "";
  }

  document.addEventListener("click", function (event) {
    var btn = event.target && event.target.closest ? event.target.closest(".customize-length-button") : null;
    if (btn) {
      event.preventDefault();
      openCustomLengthDrawer(btn.dataset.templateId || "js-custom-length-content");
      return;
    }

    var closeBtn = event.target && event.target.closest ? event.target.closest(".js-drawer-close") : null;
    if (closeBtn) {
      event.preventDefault();
      closeCustomLengthDrawer();
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || form.id !== "js-custom-length-form") {
      return;
    }
    var submitBtn = document.getElementById("js-custom-length-form-submit-btn");
    submitCustomLengthForm(event, submitBtn);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeCustomLengthDrawer();
    }
  });
})();
